import reportsSubNavUrl from './reportsSubNavComponent.html';

export default {
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "reports" */ './reportsSubNavComponentCtrl')).default,
  controllerAs: 'ctrl',
  templateUrl: reportsSubNavUrl,
  transclude: true,
};
